import React from "react";
import getClassNameFactory from "../../utilities/classNames";
import classNames from "classnames";
import { BlockColors } from "./BlockTypes";

var Block = function Block(_ref) {
  var color = _ref.color,
      height = _ref.height,
      text = _ref.text,
      rounded = _ref.rounded;
  var getClassName = getClassNameFactory(Block.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames(color, {
        rounded: rounded
      })
    }),
    style: {
      height: height
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "text"
    })
  }, text));
};

Block.displayName = "Block";
Block.defaultProps = {
  color: BlockColors.BLUE,
  height: "auto",
  text: "Block",
  rounded: false
};
export default Block;